module.exports = __webpack_public_path__ + "img/login_logo.55e6091c.png";